const newTheme = {
  primary: process.env.VUE_APP_PRIMARY_COLOR || "#FB9716",
  secondary: process.env.VUE_APP_PRIMARY_COLOR || "#EAB23C",
  rufous: "#212AD2",
  accent: "#E86413",
  error: "#f44336",
  warning: "#ff9800",
  info: "#03a9f4",
  success: process.env.VUE_APP_PRIMARY_COLOR || "#FB9716",
  anchor: "red",
  white: "#fff",
  blue: "#212AD2",
  success_icon: "#4caf50",
};

export default newTheme;
